import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ExpandMore } from '@material-ui/icons';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';

const styles = theme => ({
  root: {
    borderRadius: theme.radius.xxl,
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fill: theme.palette.facet.primaryGray,
  },
  text: {},
});

const MoreOptionsIndicator = ({
  className,
  classes,
}) => {
  return (
    <Paper
      className={classNames(classes.root, className)}
      variant={'tight'}
    >
      <ExpandMore
        className={classes.icon}
        fontSize="large"
        color="primary"
      />
    </Paper>
  );
};

MoreOptionsIndicator.defaultProps = {
  className: '',
};

MoreOptionsIndicator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MoreOptionsIndicator);
